import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/mainComponents/Button';
import { Illustration } from 'src/components/mainComponents/Illustration';
import { Stack } from 'src/components/mainComponents/Stack/Stack';
import { CommonPagesLayout } from 'src/components/v2/layouts';
import { useAuth } from 'src/user';

import './NotFoundPage.scss';

export function NotFoundPage() {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const isLoggedIn = auth?.isLoggedIn;
  return (
    <CommonPagesLayout>
      <Stack alignment='center' className='NotFoundPage'>
        <Illustration name='robot-disappointed' size='lg' />
        <p className='NotFoundPage__message'>{t('NotFoundPage.message')}</p>
        {isLoggedIn ? (
          <Button as='a' to='/'>
            {t('NotFoundPage.back_to_home')}
          </Button>
        ) : (
          <Button as='a' to='/login'>
            {t('NotFoundPage.connection')}
          </Button>
        )}
      </Stack>
    </CommonPagesLayout>
  );
}
